import { render, staticRenderFns } from "./DigitalizationPage.vue?vue&type=template&id=465f51c0&scoped=true"
import script from "./DigitalizationPage.vue?vue&type=script&lang=js"
export * from "./DigitalizationPage.vue?vue&type=script&lang=js"
import style0 from "./DigitalizationPage.vue?vue&type=style&index=0&id=465f51c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465f51c0",
  null
  
)

export default component.exports